var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6451 20C6.90061 20 3.03784 16.1854 3.03784 11.5C3.03784 6.81463 6.90061 3 11.6451 3C16.3896 3 20.2524 6.81463 20.2524 11.5C20.2524 16.1854 16.3896 20 11.6451 20ZM11.6451 4.2439C7.58919 4.2439 4.29744 7.50293 4.29744 11.5C4.29744 15.4971 7.58919 18.7561 11.6451 18.7561C15.701 18.7561 18.9928 15.4971 18.9928 11.5C18.9928 7.50293 15.701 4.2439 11.6451 4.2439Z",
    fill: "black",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2651 21.7499C21.0727 21.7499 20.8803 21.6799 20.7284 21.5299L18.7032 19.5299C18.4095 19.2399 18.4095 18.7599 18.7032 18.4699C18.9968 18.1799 19.4829 18.1799 19.7765 18.4699L21.8018 20.4699C22.0954 20.7599 22.0954 21.2399 21.8018 21.5299C21.6499 21.6799 21.4575 21.7499 21.2651 21.7499Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.644f98681cd83c2b8f3e6363db48664a.svg";
export { ForwardRef as ReactComponent };